<template>
  <el-select :placeholder="props.placeholder || $t('common.please.select')" style="width: 200px"
             :model-value="props.modelValue"
             @change="emitValue"
             @visible-change="handleVisibleChange"
             popper-class="my-select"
             :filter-method="customFilter"
             filterable
             size="small"
             :loading="props.loading"
             loading-text=""
  >
    <!-- 循环 -->
    <el-option :value="9999" :label="$t('customer.select')" v-if="props.newCusomerFlag"/>
    <el-option
        v-if="selectedCustomerOption"
        :label="selectedCustomerOption.customerName"
        :value="selectedCustomerOption.id"
    />
    <div ref="scrollContainerRef" @scroll="handleScroll" :style="`max-height: ${props.newCusomerFlag ? 226 : 260}px;overflow-y: scroll;`">
      <el-option v-for="item in customerListAll" :label="item.customerName" :value="item.id"
                 :key="item.id">
        <template #default>
          <div class="inner_select">
            {{ item.customerName }}
          </div>
        </template>
      </el-option>
      <ElSelectLoading
          v-if="isFetchingPage"
          :hasMore="true"
          :loadingText="$t('common.loading')"
      />
      <!-- 已加载全部数据，仅在有数据时提示，避免空列表误显示“到底了” -->
      <ElSelectLoading
          v-else-if="customerListAll.length && !hasMore"
          :hasMore="false"
      />
      <!-- 暂无数据 -->
      <el-option
          v-else-if="!customerListAll.length"
          class="customer-select__empty"
          value=""
          disabled
      >
        {{ $t('common.data.empty') }}
      </el-option>
      <!--      <el-option v-if="loadingCustomer" :value="null" disabled>{{ $t('common.loading') }}</el-option>-->
    </div>
  </el-select>
</template>

<script setup>
import {defineProps, onMounted, ref, watch, defineExpose, computed} from 'vue';
import {ElMessage} from 'element-plus';
import {requestAllCustomer} from '../api/customer';
import {debouncePlus, throttle} from "@/utils/mylodash";
import {useStore} from "vuex";
import ElSelectLoading from "@/components/Select/ElSelectLoading.vue";

const store = useStore()
const props = defineProps({
  modelValue: [String, Number],
  teamId: [String, Number],
  selectedLabel: {type: String, default: () => ''},
  placeholder: {type: String, default: () => ''},
  modelModifiers: {default: () => ({})},
  newCusomerFlag: {default: () => false, type: Boolean},
  loading: {type: Boolean, default: () => false},
  autoLoadOnTeamChange: {type: Boolean, default: () => true},
  // 是否在点击展开下拉框时触发数据请求；
  // 置为 false 时改由外部（如高级搜索抽屉打开）主动调用 ensureLoaded 加载，点击展开不再请求
  loadOnVisible: {type: Boolean, default: () => true},
  // 所在容器（如抽屉/弹窗）是否处于打开状态；
  // 由 false -> true 时自动预加载客户数据，避免依赖父组件 ref + nextTick 的挂载时序（抽屉懒渲染时 ref 可能尚未就绪）
  active: {type: Boolean, default: () => false},
})
const customerListAll = computed(() => store.state.customer.customerListAll)
const selectedCustomerOption = computed(() => {
  if (props.modelValue === '' || props.modelValue === null || props.modelValue === undefined) {
    return null
  }
  if (!props.selectedLabel) {
    return null
  }
  if (customerListAll.value.some(item => String(item.id) === String(props.modelValue))) {
    return null
  }
  return {
    id: props.modelValue,
    customerName: props.selectedLabel,
  }
})
const loadingCustomer = ref(false);
const isFetchingPage = ref(false)
const lastLoadTs = ref(0)
const loadCooldownMs = 500
const bottomThresholdPx = 320
const canTriggerLoadMore = ref(true)
const page = ref(1);
const size = ref(20);
const total = ref(0);
// true = 还有更多数据；false = 已到最后一页
const hasMore = ref(true);
const scrollContainerRef = ref(null)
const initializedTeamId = ref(null)
const requestVersion = ref(0)
// 下拉框是否处于展开状态，用于团队切换时判断是否需要立即重新拉取数据并展示 loading
const dropdownVisible = ref(false)


const emit = defineEmits(['update:modelValue', 'change', 'loaded', 'loading']);

function emitValue(value) {
  console.log('组件更新', value);
  emit('update:modelValue', value);
  emit('change', value);
}

function handleVisibleChange(visible) {
  dropdownVisible.value = visible
  if (!visible) return
  // 关闭“点击展开即请求”：数据由外部在抽屉打开时预加载，点击展开不再重复请求
  if (!props.loadOnVisible) return
  if (!props.teamId) return
  if (String(initializedTeamId.value) === String(props.teamId) || isFetchingPage.value) return
  initGetAllCustomer()
}

// 首次搜索要清空
const isSearch = ref(true)

async function getAllCustomer(val) {
  if (isFetchingPage.value) return
  const currentRequestVersion = requestVersion.value
  const requestTeamId = props.teamId
  const requestPage = page.value
  isFetchingPage.value = true

  // 只有首次加载/搜索时才显示 loading，分页追加时不闪烁
  const showLoading = page.value === 1
  const prevScrollTop = scrollContainerRef.value?.scrollTop
  if (showLoading) {
    loadingCustomer.value = true
    emit('loading', true)
  }

  await requestAllCustomer({
    teamId: requestTeamId,
    type: 1,
    pageNo: requestPage,
    pageSize: size.value,
    search: search.value,
  }).then(async (res) => {
    if (currentRequestVersion !== requestVersion.value || String(requestTeamId) !== String(props.teamId)) {
      return
    }
    console.log('客户列表', res);
    const records = res?.result?.records || []
    total.value = Number(res?.result?.total || 0)

    if (records.length > 0 || requestPage === 1) {
      // if (props.newCusomerFlag) {
      //   res.result.records.unshift({id: 9999, customerName: "新建客户"});
      // }
      if (search.value !== "" && search.value !== undefined && search.value !== undefined && isSearch.value) {
        await store.commit("customer/setCustomerListAll", [])
        isSearch.value = false
      }
      const baseList = requestPage === 1 ? [] : customerListAll.value
      const payload = [...baseList, ...records].reduce((acc, current) => {
        if (!acc.some(item => item.id === current.id)) {
          acc.push(current);
        }
        return acc;
      }, []);
      await store.commit("customer/setCustomerListAll", payload)
      emit('loaded', payload)
    } else {
      hasMore.value = false
      emit('loaded', [])
    }

    // 是否还有更多（true = 还有更多，可以继续翻页）
    if (total.value > 0) {
      hasMore.value = page.value * size.value < total.value
    } else {
      // 后端未返回 total 时，按本次返回数量判断
      hasMore.value = records.length >= size.value
    }

    if (showLoading) {
      loadingCustomer.value = false
      emit('loading', false)
    }

    // 分页追加时尽量保持滚动位置，避免闪一下/跳动
    if (!showLoading && typeof prevScrollTop === 'number' && scrollContainerRef.value) {
      scrollContainerRef.value.scrollTop = prevScrollTop
    }
    }).catch(e => {
    if (currentRequestVersion !== requestVersion.value || String(requestTeamId) !== String(props.teamId)) {
      return
    }
    const msg = e?.response?.data?.message || e?.message || e;
    ElMessage.error(String(msg || '操作失败'));
    loadingCustomer.value = false
    emit('loading', false)
    emit('loaded', [])
  }).finally(() => {
    if (currentRequestVersion === requestVersion.value) {
      isFetchingPage.value = false
    }
  })
}

const loadNextPage = async () => {
  if (isFetchingPage.value) return
  if (!hasMore.value) return
  page.value = page.value + 1
  await getAllCustomer()
}

const search = ref('')
const customFilter = debouncePlus((val) => {
  // el-select 展开时会以当前输入值（通常为空串）自动调用一次 filter-method，
  // 若过滤词相比当前 search 未发生变化，则视为“展开触发的空查询”，直接跳过，
  // 避免绕过 loadOnVisible 在点击展开瞬间误发 /front/mailCustomer/getAllCustomer 请求；
  // 真实的搜索输入会改变 val，仍会正常触发请求
  if (String(val ?? '') === String(search.value ?? '')) return
  isSearch.value = true
  page.value = 1
  search.value = val
  hasMore.value = true
  canTriggerLoadMore.value = true
  getAllCustomer()
}, 1000)

const handleScroll = throttle((event) => {
  console.log('getAllCustomer=======')
  const el = event?.target
  if (!el) return
  if (isFetchingPage.value) return

  const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight
  const dynamicThreshold = Math.floor(el.clientHeight * 0.75)
  const threshold = Math.max(bottomThresholdPx, dynamicThreshold)

  // 用户滚离底部一定距离后，重新“解锁”下一次触发
  if (distanceToBottom > threshold) {
    canTriggerLoadMore.value = true
    return
  }

  // 已经到最后一页就不再分页
  if (!hasMore.value) return
  // 底部区域只触发一次，避免停留在底部时连续请求
  if (!canTriggerLoadMore.value) return

  const now = Date.now()
  if (now - lastLoadTs.value < loadCooldownMs) return
  lastLoadTs.value = now

  canTriggerLoadMore.value = false
  loadNextPage()
}, 100)

async function initGetAllCustomer() {
  if (isFetchingPage.value) return
  // 先重置缓存标记与缓存数据，再发起请求，保证切换团队后不会用到上一个团队的客户数据；
  // 将重置逻辑放在 isFetchingPage 守卫之后、requestAllCustomer 之前，
  // 确保无论从哪里调用（watch / ensureLoaded / handleVisibleChange），
  // 重置都发生在 /mailCustomer/getAllCustomer 请求之前
  initializedTeamId.value = props.teamId ?? null
  // 同步执行 commit（Vuex commit 本身是同步的），不要 await：
  // 否则后续 getAllCustomer() 中的 isFetchingPage=true 会被推迟到微任务，
  // 导致下拉框展开时先渲染一帧空白/暂无数据，再出现 loading，产生闪烁。
  store.commit("customer/setCustomerListAll", [])
  page.value = 1;
  hasMore.value = true;
  canTriggerLoadMore.value = true
  getAllCustomer();
}

// 当前团队数据尚未加载时才加载一次，已加载过则跳过，避免重复请求（用于打开高级搜索抽屉时预加载）
function ensureLoaded() {
  if (!props.teamId) return
  if (isFetchingPage.value) return
  if (String(initializedTeamId.value) === String(props.teamId)) return
  initGetAllCustomer()
}

watch(() => props.teamId, () => {
  console.log(props.teamId);
  requestVersion.value += 1
  // 切换团队时立即失效缓存标记，避免 ensureLoaded / handleVisibleChange 在新团队下误判为"已加载"
  initializedTeamId.value = null
  isFetchingPage.value = false
  loadingCustomer.value = false
  page.value = 1
  total.value = 0
  hasMore.value = true
  canTriggerLoadMore.value = true
  isSearch.value = true
  search.value = ""
  // 立即清空 CustomerSelect 中缓存的客户列表数据，确保切换团队后不会沿用上一个团队的数据；
  // 该重置在后续 initGetAllCustomer（即 /mailCustomer/getAllCustomer 请求）之前执行
  store.commit("customer/setCustomerListAll", [])
  // 团队切换后，上一个团队选中的客户在新团队下已无效，主动重置 v-model 清空选中项，
  // 避免 selectedCustomerOption 仍渲染上一个团队的客户而出现数据闪烁（不依赖父组件同步重置）；
  // 只发 update:modelValue、不发 change，避免触发父组件 @change 的副作用（如携空 id 发请求）
  if (props.modelValue !== '' && props.modelValue !== null && props.modelValue !== undefined) {
    emit('update:modelValue', '')
  }
  // 团队切换时：需要自动加载，或下拉框正处于展开状态时，
  // 立即重新拉取新团队数据并展示 loading，避免直接从上一个团队的数据跳到下一个团队的数据，影响体验
  if (props.autoLoadOnTeamChange || dropdownVisible.value) {
    initGetAllCustomer();
  } else {
    emit('loading', false)
  }
});

// 容器打开（如高级搜索抽屉展开）时强制重新拉取：每次 false -> true 请求一次，
// 不做同团队去重，保证每次打开抽屉都会请求一次 /front/mailCustomer/getAllCustomer；
// 使用 immediate，覆盖抽屉懒渲染导致组件在 active 已为 true 后才挂载的场景
watch(() => props.active, (val) => {
  if (val) initGetAllCustomer()
}, {immediate: true})

defineExpose({
  initGetAllCustomer,
  getAllCustomer,
  ensureLoaded,
});

onMounted(() => {
  // getAllCustomer();
  search.value = ""
});
</script>

<style lang="less" scoped>
.inner_select {
  width: auto;
  max-width: 400px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.customer-select__empty {
  text-align: center;
  color: var(--el-color-info);
  font-size: 12px;
}
</style>
